import { CreativesListItem, CreativeStatus } from 'components/common/types/Creative.types';
import Local from 'modules/Local';
import { CreativesTableFilters, MapFiltersToRequestData, PreparedCreativeForTable } from './CreativesTable.type';
import { SelectedCreativeTypes } from '../AssignCreativeModal.types';

export const prepareCreativesList = (creatives: CreativesListItem[]): PreparedCreativeForTable[] =>
  creatives.map((creative) => {
    const currentMarket = creative.market.find((market) => market.environment === Local.getEnvironmentId());

    return {
      ...creative,
      status: currentMarket?.moderation[0].status ?? CreativeStatus.PENDING,
      advertiser: currentMarket?.commercial?.advertiser,
      brand: currentMarket?.commercial?.brand,
      size: creative.width && creative.height ? `${creative.width} x ${creative.height}` : '',
    };
  });

export const mapFiltersToRequestData = ({
  dsp,
  advertiser,
  brand,
  creativeType,
}: CreativesTableFilters): MapFiltersToRequestData => ({
  ...(dsp ? { dspName: dsp.name } : {}),
  ...(advertiser ? { advertiserCode: advertiser.code } : {}),
  ...(brand ? { brandCode: brand.code } : {}),
  ...(creativeType ? { type: creativeType } : {}),
});

export const mapSelectedRowToCreative = ({
  thumbnail: thumbnailUrl,
  downloadURL: previewUrl,
  id,
  ...otherCreativeData
}: PreparedCreativeForTable): SelectedCreativeTypes => ({
  id: String(id),
  thumbnailUrl,
  previewUrl,
  ...otherCreativeData,
});
